import List from "@material-ui/core/List/List";
import AccountBox from "@material-ui/icons/AccountBox";
import Delete from "@material-ui/icons/Delete";
import Drafts from "@material-ui/icons/Drafts";
import Link from "@material-ui/icons/Link";
import FindInPage from "@material-ui/icons/FindInPage";
import LocalOffer from "@material-ui/icons/LocalOffer";
import NoteAdd from "@material-ui/icons/NoteAdd";
import PowerSettingsNew from "@material-ui/icons/PowerSettingsNew";
import * as React from "react";
import { RouteComponentProps } from 'react-router-dom';
import { AuthContext } from "../auth-context";
import { Content } from "../components/content";
import { MediaLines } from "../components/daily-media-line";
import { DOCUMENT_TYPE_ICONS } from "../components/document-icons";
import { Iif } from "../components/iif";
import { ListMenuItem, Spacer } from "../components/utility-components";
import { AbstractDocumentKind } from "../model/autogen/AbstractDocumentKind";
import { UserLevel } from "../model/autogen/UserLevel";
import { RoutePaths, UserSearchRoute } from '../route-paths';
import PageTitles from "./titles";
import { SearchableContentType } from "../model/autogen/SearchableContentType";
import { withAuthContext, IAuthContextProps } from "../components/with-auth-context";
import { SpeakingListRequestFactory } from "../model/autogen/SpeakingListController";
import { FileModel } from "../model/autogen/FileModel";
import { FilesRequestFactory } from "../model/autogen/FilesController";
import { downloadLinkResolver } from "./brief-item-page";
import { TopLineUsageContext } from "model/autogen/TopLineUsageContext";

type HomePageProps = RouteComponentProps & IAuthContextProps
class HomePage extends React.Component<HomePageProps> {
    public render() {
        return <>
            <div style={{ textAlign: 'center' }} >
                <br />
            </div>
            <Content>
                <AuthContext.Consumer>
                    {({ methods, state: { user } }) => (<>
                        <Iif show={user.level !== UserLevel.SystemUser}>
                            <MediaLines context={TopLineUsageContext.MediaLines} enableEdit={false} isExternal={true} />
                        </Iif>
                        <Spacer />
                        <Iif show={user.level > UserLevel.External}>
                            <MediaLines context={TopLineUsageContext.MediaLines} enableEdit={false} isExternal={false} />
                        </Iif>
                    </>)}
                </AuthContext.Consumer>
            </Content>
            <Spacer />
            <List component="nav">
                <AuthContext.Consumer>
                    {({ methods, state: { user } }) => (<>
                        <ListMenuItem className="app-home-link-todays-lines" onClick={this.onListLines} icon={DOCUMENT_TYPE_ICONS[AbstractDocumentKind.MediaLines]}>{PageTitles.LINES}</ListMenuItem>
                        <ListMenuItem className="app-home-link-debate-notes" onClick={this.onListNotes} icon={DOCUMENT_TYPE_ICONS[AbstractDocumentKind.DebateNotes]}>{PageTitles.DEBATE_NOTES}</ListMenuItem>
                        <Iif show={user.level >= UserLevel.SystemUser}>
                            <ListMenuItem className="app-home-link-speaking-list" onClick={this.onSpeakingList} icon={DOCUMENT_TYPE_ICONS[SearchableContentType.Quote]}>{PageTitles.SPEAKING_LIST}</ListMenuItem>
                        </Iif>
                        <Iif show={user.level > UserLevel.External}>
                            <ListMenuItem className="app-home-link-briefs" onClick={this.onListBriefs} icon={DOCUMENT_TYPE_ICONS[AbstractDocumentKind.IssueBrief]}>{PageTitles.BRIEFS}</ListMenuItem>
                            <ListMenuItem className="app-home-link-achievements" onClick={this.onListAchievements} icon={DOCUMENT_TYPE_ICONS[AbstractDocumentKind.Achievement]}>{PageTitles.ACHIEVEMENTS}</ListMenuItem>
                            <ListMenuItem className="app-home-link-resources" onClick={this.onListResources} icon={DOCUMENT_TYPE_ICONS[AbstractDocumentKind.Resource]}>{PageTitles.RESOURCES}</ListMenuItem>
                            <ListMenuItem className="app-home-link-profiles" onClick={this.onListProfiles} icon={DOCUMENT_TYPE_ICONS[AbstractDocumentKind.ProfileOfMP]}>{PageTitles.MP_PROFILES}</ListMenuItem>
                        </Iif>
                        <Iif show={user.level >= UserLevel.Editor}>
                            <ListMenuItem className="app-home-link-people" onClick={this.onListPeople} icon={DOCUMENT_TYPE_ICONS[AbstractDocumentKind.Person]}>{PageTitles.PEOPLE}</ListMenuItem>
                        </Iif>
                        <Iif show={user.level >= UserLevel.SystemUser}>
                            <ListMenuItem className="app-home-link-faqs" onClick={this.onListFaqs} icon={DOCUMENT_TYPE_ICONS[AbstractDocumentKind.FAQ]}>{PageTitles.FAQS}</ListMenuItem>
                            <ListMenuItem className="app-home-link-opeds" onClick={this.onListOpeds} icon={DOCUMENT_TYPE_ICONS[AbstractDocumentKind.OpinionEditorial]}>{PageTitles.OPINION_EDITORIALS}</ListMenuItem> 
                            <ListMenuItem className="app-home-link-quote" onClick={this.onListQuotes} icon={DOCUMENT_TYPE_ICONS[SearchableContentType.Quote]}>{PageTitles.QUOTES}</ListMenuItem> 
                        </Iif>
                        <Iif show={user.level >= UserLevel.External}>
                            <ListMenuItem className="app-home-link-advanced-search" onClick={this.onAdvanced} icon={<FindInPage />}>{PageTitles.ADVANCED_SEARCH}</ListMenuItem>
                        </Iif>
                        <ListMenuItem className="app-home-link-data-entry" onClick={this.onDataEntry} icon={<NoteAdd />}>{PageTitles.DATA_ENTRY}</ListMenuItem>
                        <Iif show={user.level >= UserLevel.Editor}>
                            <ListMenuItem className="app-home-link-unpublished-content" onClick={this.onUnpublishedContent} icon={<Drafts />}>{PageTitles.UNPUBLISHED_CONTENT}</ListMenuItem>
                            <ListMenuItem className="app-home-link-tags" onClick={this.onTags} icon={<LocalOffer />}>{PageTitles.TAGS}</ListMenuItem>
                            <ListMenuItem className="app-home-link-tags" onClick={this.onResOnlyTags} icon={<LocalOffer />}>{PageTitles.RESOURCE_ONLY_TAGS}</ListMenuItem>
                        </Iif>
                        <Iif show={user.level >= UserLevel.Admin}>
                            <ListMenuItem className="app-home-link-manage-users" onClick={this.onManageUsers} icon={<AccountBox />}>Manage Users</ListMenuItem>
                        </Iif>
                        <Iif show={user.level >= UserLevel.Editor}>
                            <ListMenuItem className="app-home-link-archived-content" onClick={this.onArchivedContent} icon={<Delete />}>Archived Content</ListMenuItem>
                        </Iif>
                        <ListMenuItem className="app-home-link-nzlc" onClick={this.onNzlc} icon={<Link />}>Go to Labour Connect</ListMenuItem>
                        <ListMenuItem className="app-home-link-logout" onClick={() => methods.setToken(undefined)} icon={<PowerSettingsNew />}>Log Out</ListMenuItem>
                    </>)}
                </AuthContext.Consumer>
            </List>
        </>;
    }
    private onAdvanced = (e: any) => {
        this.props.history.push(RoutePaths.AdvancedSearch);
    }
    private onDataEntry = (e: any) => {
        this.props.history.push(RoutePaths.DataEntry);
    }
    private onManageUsers = () => this.props.history.push(UserSearchRoute(''));
    private onListLines = (e: any) => {
        this.props.history.push(RoutePaths.Lines);
        //this.props.history.push({ pathname: RoutePaths.AdvancedSearch, search: `?type=${AbstractDocumentKind.MediaLines}&autoSearch=1` });
    }
    private onListNotes = (e: any) => {
        this.props.history.push(RoutePaths.Notes);
        //this.props.history.push({ pathname: RoutePaths.AdvancedSearch, search: `?type=${AbstractDocumentKind.DebateNotes}&autoSearch=1` });
    }
    private onListBriefs = (e: any) => {
        this.props.history.push(RoutePaths.IssueBriefs);
        //this.props.history.push({ pathname: RoutePaths.AdvancedSearch, search: `?type=${AbstractDocumentKind.IssueBrief}&autoSearch=1` });
    }
    private onListAchievements = (e: any) => {
        this.props.history.push(RoutePaths.Achievements);
    }
    private onListResources = (e: any) => {
        this.props.history.push(RoutePaths.Resources);
    }
    private onListProfiles = (e: any) => {
        this.props.history.push(RoutePaths.MPs)
        //this.props.history.push({ pathname: RoutePaths.AdvancedSearch, search: `?type=${AbstractDocumentKind.ProfileOfMP}&autoSearch=1` });
    }
    private onListPeople = (e: any) => {
        this.props.history.push(RoutePaths.People)
        //this.props.history.push({ pathname: RoutePaths.AdvancedSearch, search: `?type=${AbstractDocumentKind.ProfileOfMP}&autoSearch=1` });
    }
    private onListFaqs = (e: any) => {
        this.props.history.push(RoutePaths.FAQ);
        //this.props.history.push({ pathname: RoutePaths.AdvancedSearch, search: `?type=${AbstractDocumentKind.FAQ}&autoSearch=1` });
    }
    private onListOpeds = (e: any) => {
        this.props.history.push(RoutePaths.OpinionEditorials);
        //this.props.history.push({ pathname: RoutePaths.AdvancedSearch, search: `?type=${AbstractDocumentKind.FAQ}&autoSearch=1` });
    }

    private onListQuotes = (e: any) => {
        this.props.history.push(RoutePaths.Quotes);
    }
    
    private onArchivedContent = (e: any) => {
        this.props.history.push(RoutePaths.ArchivedContent);
    }
    private onUnpublishedContent = (e: any) => {
        this.props.history.push(RoutePaths.UnPublishedDrafts);
    }
    private onTags = (e: any) => {
        this.props.history.push(RoutePaths.Tags);
    }
    private onResOnlyTags = (e: any) => {
        this.props.history.push(RoutePaths.ResourceOnlyTags);
    }
    private onNzlc = (e: any) => {
        window.open("https://connect.labour.org.nz");
    }
    private download = async (fileModel: FileModel | undefined) => {
        if (fileModel) {
            const result = await this.props.callApi((fetcher) => FilesRequestFactory.requestDownload(fetcher, fileModel.id));
            const downloadLink = downloadLinkResolver(result.id);
            if (fileModel.mimeType === "application/pdf") {
                window.open(downloadLink)
            } else {
                window.location.href = downloadLink;
            }
        }
    }
    private onSpeakingList = async (e: any) => {
        const speakingList = await this.props.callApi((fetcher) => SpeakingListRequestFactory.getSpeakingList(fetcher))
        if (this.props.user.level < UserLevel.Editor && speakingList) {
            await this.download(speakingList.file);
        } else {
            this.props.history.push(RoutePaths.SpeakingList);
        }
    }
}

export const Home = withAuthContext(HomePage, UserLevel.External) as React.ComponentType<RouteComponentProps>;




// WEBPACK FOOTER //
// ./src/pages/Home.tsx